export class dropdowns {
    static TEACHERS = { id: 'teacher-dropdown', key: 'userProfileId', customLabel: item => `${item.displayTitle} ${item.firstName} ${item.lastName}` };
    static CLASSES = { id: 'classes-dropdown', key: 'classroomId', label: 'name' };
    static GROUPS = { id: 'groups-dropdown', key: 'id', label: 'name' };
}

export class buttons {
    static DOWNLOAD = { id: 'download-button' }
}



// WEBPACK FOOTER //
// ./app/components/download-certificates/constants.js